import React, {Component, Fragment} from "react";
import PropTypes from "prop-types";
import {ListingSummary} from "./ListingSummary";
import * as ListingProps from "./listing-props";
import {ListingProviderAndImage} from "./ListingProviderAndImage";
import {ListingTitle} from "./ListingTitle";

/**
 * renders 3 columns:
 * |  provider |             |          |
 * |  image    |best listing |duplicate |
 * |           |             |          |
 *                           |          |
 *                           |          |
 *                           |duplicate |
 *                           |          |
 *                           |          |
 *                           |          |
 *                           | etc      |
 *                           |          |
 *                           |          |
 */
export class DuplicateListingsSummary extends Component {
  static propTypes = {
    bestListing: ListingProps.listing.isRequired,
    duplicateListings: PropTypes.arrayOf(ListingProps.listing).isRequired
  };

  render() {
    const {bestListing, duplicateListings} = this.props
    return (

      <div className="row">
        <div className="col-sm-4">
          <ListingProviderAndImage listing={bestListing}/>
        </div>
        <div className="col-sm-4">
          <ListingTitle title="Primary Listing"/>
          <ListingSummary
            listing={{
              ...bestListing.foundLocation,
              website: bestListing.foundURL,
              listingURL: bestListing.listingURL
            }}
            matchErrors={bestListing.matchErrors}
          />
        </div>
        <div className="col-sm-4">
          {
            duplicateListings.map((x, i) => {
              return <Fragment key={x.listingId}>
                <ListingTitle title={`${i + 1}. Duplicate Listing`} />
                <ListingSummary
                  listing={{...x.foundLocation, website: x.foundURL, listingURL: x.listingURL}}
                  matchErrors={bestListing.matchErrors}
                />
                {i === duplicateListings.length - 1 ? undefined : <hr />}
              </Fragment>
            })
          }
        </div>
      </div>
    );
  }
}